import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { InboxFilter } from '../../types/InboxTypes';
import {
    requestCreateFilter,
    requestDeleteSavedFilter,
    requestSavedFilters,
    requestUpdateSavedFilter,
} from '../savedFilters/savedFilters';

export function useSavedFilters() {
    return useQuery<InboxFilter[], Error>({
        queryKey: ['savedFilters'],
        queryFn: async ({ signal }) => (await requestSavedFilters(signal)).data,
    });
}

export function useCreateSavedFilter() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (filter: InboxFilter) => (await requestCreateFilter(filter)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['savedFilters'] });
        },
    });
}

export function useUpdateSavedFilter() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (filter: InboxFilter) => (await requestUpdateSavedFilter(filter)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['savedFilters'] });
        },
    });
}

export function useDeleteSavedFilter() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (filterId: number) => (await requestDeleteSavedFilter(filterId)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['savedFilters'] });
        },
    });
}
